import { EventEmitter } from '@flatbiz/utils';

interface LayoutEventPayloadMap {
  /** 弹框打开处理 */
  updateTheme: { theme: 'dark' | 'light' };
}

type LayoutEvent = keyof LayoutEventPayloadMap;

const eventEmitter = new EventEmitter<LayoutEventPayloadMap>();

export const layoutPubSub = {
  /** 发布 */
  publish<K extends LayoutEvent>(event: K, data: LayoutEventPayloadMap[K]) {
    eventEmitter.publish<LayoutEvent>(event, data);
  },

  /** 订阅 */
  subscribe<K extends LayoutEvent>(
    event: K,
    callback: (data: LayoutEventPayloadMap[K]) => void
  ) {
    eventEmitter.subscribe(event, callback);
  },

  /** 取消订阅 */
  unsubscribe<K extends LayoutEvent>(
    event: K,
    callback: (data: LayoutEventPayloadMap[K]) => void
  ) {
    eventEmitter.unsubscribe(event, callback);
  },
};
